module.exports = __webpack_public_path__ + "img/wechatpay.6bdaed71.svg";